import BaseViewController from "../base-view-controller";
import { FIELD_NAMES } from "../../utils/constants";

class FamilyViewController extends BaseViewController {
  preprocessScreenData() {
    this.cleanUpHistory();

    const { fields } = this.screen;

    if (fields.find(f => f.name === FIELD_NAMES.dependentsTitle)) {
      const DependentsContainer = fields.find(
        f => f.name === FIELD_NAMES.dependentsTitleField
      ).fieldLayouts[0].containerFields;
      const DependentsTitle = fields.splice(
        fields.findIndex(f => f.name === FIELD_NAMES.dependentsTitle),
        1
      );
      DependentsContainer.unshift(DependentsTitle[0]);

      if (fields.find(f => f.name === FIELD_NAMES.dependentsAddField)) {
        const DependentsAddButton = fields.splice(
          fields.findIndex(f => f.name === FIELD_NAMES.dependentsAddField),
          1
        );
        DependentsContainer.push(DependentsAddButton[0]);
      }
    }
    if (fields.find(f => f.name === FIELD_NAMES.authorizedConsenterTitle)) {
      const AuthorizedConsentersContainer = fields.find(
        f => f.name === FIELD_NAMES.authorizedConsenterTitleField
      ).fieldLayouts[0].containerFields;
      const AuthorizedConsenterTitle = fields.splice(
        fields.findIndex(f => f.name === FIELD_NAMES.authorizedConsenterTitle),
        1
      );
      const AuthorizedConsenterAddButton = fields.splice(
        fields.findIndex(
          f => f.name === FIELD_NAMES.authorizedConsenterAddField
        ),
        1
      );
      AuthorizedConsentersContainer.unshift(AuthorizedConsenterTitle[0]);
      AuthorizedConsentersContainer.push(AuthorizedConsenterAddButton[0]);
    }
    if (fields.find(f => f.name === FIELD_NAMES.careRecipientsTitle)) {
      const CareRecipientContainer = fields.find(
        f => f.name === FIELD_NAMES.careRecipientsTitleField
      ).fieldLayouts[0].containerFields;
      const CareRecipientTitle = fields.splice(
        fields.findIndex(f => f.name === FIELD_NAMES.careRecipientsTitle),
        1
      );
      const CareRecipientAddButton = fields.splice(
        fields.findIndex(f => f.name === FIELD_NAMES.careRecipientsAddField),
        1
      );
      CareRecipientContainer.unshift(CareRecipientTitle[0]);
      CareRecipientContainer.push(CareRecipientAddButton[0]);
    }
  }

  cleanUpHistory() {
    let history = this.appData.history;

    const urlsToRemove = [
      "screens/authorized_consenter_new",
      "screens/authorized_consenter_remove",
      "screens/authorized_consenter_edit",
      "/screens/unified_profile/family/authorized_consenter_add",
      "/screens/unified_profile/family/authorized_consenter_edit",
      "/screens/care_recipient",
      "/screens/care_recipient/delete",
      "/screens/add_care_recipient_modal",
      "/screens/add_care_recipient_modal_screen"
    ];

    for (let i = 0; i < history.length; i++) {
      if (urlsToRemove.includes(history[i].url)) history.splice(i, 1);
    }

    // Temporary solution to avoid form fields on Add Dependent to be auto-populated after dependent save.
    const allowedValues = ["logged_in_member_id", "unified_profile_workflow"];

    Object.keys(this.appData.values).forEach(key => {
      if (!allowedValues.includes(key)) {
        delete this.appData.values[key];
      }
    });
  }
}

export default FamilyViewController;
